// @ts-nocheck
import { Plugin } from '/builds/oem/oem-fe-work-manager/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','dva',],
});

export { plugin };
